import { useCallback } from "react";

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

const NONCE_KEY = "gg_google_nonce";

function generateNonce(): string {
  const array = new Uint8Array(16);
  crypto.getRandomValues(array);
  return Array.from(array, (b) => b.toString(16).padStart(2, "0")).join("");
}

interface UseGoogleAuthProps {
  onError: (error: Error) => void;
}

export function useGoogleAuth({ onError }: UseGoogleAuthProps) {
  const signIn = useCallback(() => {
    if (!GOOGLE_CLIENT_ID) {
      onError(new Error("VITE_GOOGLE_CLIENT_ID não configurado. Defina no .env do frontend."));
      return;
    }

    const nonce = generateNonce();
    sessionStorage.setItem(NONCE_KEY, nonce);

    const params = new URLSearchParams({
      client_id: GOOGLE_CLIENT_ID,
      redirect_uri: `${window.location.origin}/auth/google/callback`,
      response_type: "id_token",
      scope: "openid email profile",
      nonce,
    });

    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params}`;
  }, [onError]);

  return { signIn };
}

export { NONCE_KEY };
